<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-05-31 10:30:45
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-05-29 09:40:30
 * @Description: 富余量审批
 * @FilePath: \ICPSxin\src\views\platform\ICPS\smart\schedul\planreview\surplusFlow.vue
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)"
            @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)"
            @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)"
            @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1"
                placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{ billCode }}</span>
                <span class="text">制单日期：{{ billDate }}</span>
              </div>
              <div class="right">
                <span>发起人：{{ applyPerson }}</span>
                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
              </div>
            </div>
            <div style="margin-top:20px;">
              <el-form :inline="true" :model="formData">
                <el-form-item>
                  <span slot="label">工程名称</span>
                  <el-input style="width:18.75rem" disabled :value="formData.engineeringName"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">富余量</span>
                  <el-select ref="addlossNum" v-model="formData.excessAllowance" multiple placeholder="请选择" @remove-tag="handleRemoveTag">
                    <el-option v-for="(v, k) in marginNumberList" :key="k" :label="v.itemName"
                      :value="v.itemName" :disabled="v.itemName == '0.0'"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible"
                @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish"
                @handleBusiness="handleBusiness" @resetFlowState="resetFlowState" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { saveSurplus, surplusApplay } from "@/api/smart/schedul/c.js";
import {getDicType } from "@/api/common.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '富余量申请',
      billCode: '',
      billDate: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      applyPerson: '',
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      formData: {},
      marginNumberList:[],
    }
  },
  methods: {
    handleRemoveTag(removeValue){
      if(removeValue == "0.0") {
        this.$message.warning("禁止删除此项")
        this.formData.excessAllowance.unshift(removeValue); 
      }
    },
    resetFlowState() {
      this.formData.approveStatus = 3
      saveSurplus(this.formData).then(res => {

        console.log(res)
      });
      this.$refs.flowcontent.handleToFlow(this.formData);
      this.showSendVisible = false;
    },
    handleBusiness() {
      const params = {
        process_success: {
          url: '/icps/system/sign/cloudSell/engineeringExtend/surplusApplay',
          data: {
            engineeringId: this.formData.engineeringId,
            excessAllowance: this.formData?.excessAllowance.length > 0  ||  this.formData.excessAllowance == 0? JSON.stringify(this.formData.excessAllowance) : "" ,
            surplusApplay: 1,
          },
          httpMethod: 'post',
        },
        process_failure: {
          url: '/icps/system/sign/cloudSell/engineeringExtend/surplusApplay',
          data: {
            engineeringId: this.formData.engineeringId,
            surplusApplay: 2,
          },
          httpMethod: 'post',
        }
      }
      // const params = {
      //   process_success: {
      //     url: '/icps/surplus/save',
      //     data:{
      //       engineeringName:this.formData.engineeringName,
      //       engineeringId:this.formData.engineeringId,
      //       startTime:this.formData.startTime,
      //       endTime:this.formData.endTime,
      //       approveStatus:2,
      //       id:this.formData.id,
      //     },
      //     httpMethod: 'post',
      //   },
      //   process_failure: {
      //   url: '/icps/surplus/save',
      //   data:{
      //       engineeringName:this.formData.engineeringName,
      //       engineeringId:this.formData.engineeringId,
      //       startTime:this.formData.startTime,
      //       endTime:this.formData.endTime,
      //       approveStatus:3,
      //       id:this.formData.id,
      //   },
      //   httpMethod: 'post',
      //  }
      // }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish(type, status) {
      console.log(type, status)
      // if (type === 1) {
      //   this.formData.approveStatus = 1
      //   saveSurplus(this.formData)
      // }
      if (type === 2 && status == '2') {
        surplusApplay({
          engineeringId: this.formData.engineeringId,
          excessAllowance:this.formData.excessAllowance.length > 0 ||  this.formData.excessAllowance == 0 ? JSON.stringify(this.formData.excessAllowance) : "" ,
          surplusApplay: 1,
        })
      }
      if (type === 2 && status == '3') {
        this.formData.surplusApplay = 2
        surplusApplay({
          engineeringId: this.formData.engineeringId,
          surplusApplay: 2,
        })
      }
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 提交流程
        this.showSendVisible = true;
        return
      }
      const data = {
        dataSource: 'surplusFlow',
        dataContent: JSON.stringify({ ...this.formData }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    initFlowsData() {
      this.isReadOnly = true;
      const { query } = this.$route;
      console.log("initFlowsData2", query);
      // const { formData} = query;
      const data = JSON.parse(query.dataContent);
      this.formData = data;
      console.log(this.formData)
      if (data.excessAllowance!== null ) {
        this.$set(this.formData, "excessAllowance", data.excessAllowance)
      } else {
        this.$set(this.formData, "excessAllowance", ["0.0"])
      }
      // this.$set(this.formData,"excessAllowance",["0.0"])
      this.formData.surplusDate = this.formData.startTime + "-" + this.formData.endTime
      this.title = this.formData.engineeringName ? this.formData.engineeringName + "-富余量申请" : "富余量申请";
    },
    initFlowsData2() {
      const { query } = this.$route;
      this.formData = JSON.parse(query.dataContent);
      this.formData.surplusDate = this.formData.startTime + "-" + this.formData.endTime
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.applyPerson = query.createUserName;
      this.billDate = query.createTime;
      this.taskStatus = query.taskStatus;
    },
    sendCode(code) {
      this.billCode = code;
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
  },
  mounted() {
    getDicType({
      code: "marginNumber",
    }).then(res => {
      this.marginNumberList = res.data.items;
    });
    const { query } = this.$route;
    if (query.type == 1) {
      // 发起流程
      this.initFlowsData();
      this.applyPerson = getUserInfo().userRealName;
      this.$refs.flowcontent.initBaseData("surplusFlow");
      this.billDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
      return;
    }
    this.initFlowsData2();
    if (query.isReadOnly * 1 === 1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}

.info {
  padding: 0 20px;
  background: #fff;

  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;

    .left {
      @include discen_al;
    }

    .text {
      margin-left: 60px;
    }
  }
}

.nav_title {
  @include discen_al;
  align-items: flex-end;

  >div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }

  i {
    margin-left: 5px;
  }

  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}</style>
  